// extracted by css-extract-rspack-plugin
export default {"tileWrapper":"_10b2665f","tileWidth":"_b88c87ca","completeInfo":"_6dba19f","favoritesWrapper":"_25c392cc"};